import styled from "styled-components";
import { colors, darkModeColors } from "../../consts";
import { FlexContainers, IconButton } from "../../components";
import { InputWrapper } from "../Input/styled";

export const SearchInputWrapper = styled(InputWrapper)`
  input {
    padding-left: ${(props) => (props?.showSearchIcon ? "52px" : "12px")};

    ${(props) => props?.icon && `padding-right: 40px`};
    ${(props) => props?.disableSearch && `cursor: pointer`};
  }
`;

export const ComponentWrapper = styled(FlexContainers.FlexRowStart)`
  background: ${darkModeColors.WHITE_RAISIN_100};
  border: 1px solid ${colors.RAISIN_50};
  border-radius: 8px;

  min-height: 48px;
  width: 100%;
  padding: 4px 12px;

  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${darkModeColors.RAISIN_100_WHITE};

  &:hover {
    box-shadow: ${(props) =>
      props?.theme?.darkMode
        ? `0px 4px 4px rgba(255, 255, 255, 0.16)`
        : `0px 4px 4px rgba(52, 48, 61, 0.16)`};
  }

  padding-left: ${(props) => (props?.showSearchIcon ? "52px" : "12px")};
  ${(props) => props?.icon && `padding-right: 40px`};
`;

export const ComponentContentWrapper = styled.div`
  transform-origin: top left;

  ${(props) =>
    props?.visible === undefined
      ? `transform: scaleX(0)`
      : props?.visible
      ? "animation: expandRight 300ms ease-in-out forwards"
      : "animation: shrinkLeft 300ms ease-in-out forwards"};
`;

export const SearchIconWrapper = styled(IconButton)`
  position: absolute;
  left: 15px;

  ${(props) =>
    props?.visible === undefined
      ? `transform: scaleX(0)`
      : props?.visible
      ? "animation: expandRight 300ms ease-in-out forwards"
      : "animation: shrinkLeft 300ms ease-in-out forwards"};

  transform-origin: top left;
`;

export const IconWrapper = styled.div`
  position: absolute;
  right: 20px;
`;
